/**
 * @param {string} title
 * @returns {string}
 */
export function buildPdfDownloadFilename(title) {
    const base =
        String(title || 'bulten')
            .trim()
            .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '')
            .replace(/\s+/g, '-')
            .slice(0, 80) || 'bulten';
    return base.toLowerCase().endsWith('.pdf') ? base : `${base}.pdf`;
}

/**
 * Uzak dosyayı blob olarak indirir (CORS izin verdiğinde).
 * @param {string} url
 * @param {string} filename
 * @param {{ accessToken?: string | null }} [opts]
 */
export async function downloadRemoteFile(url, filename, opts = {}) {
    const rawUrl = String(url || '').trim();
    if (!rawUrl) {
        throw new Error('İndirme adresi bulunamadı');
    }

    const headers = /** @type {Record<string, string>} */ ({});
    if (opts.accessToken) {
        headers.Authorization = `Bearer ${opts.accessToken}`;
    }

    const res = await fetch(rawUrl, { headers });
    if (!res.ok) {
        throw new Error(`Dosya indirilemedi (${res.status})`);
    }

    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename || 'download';
    anchor.rel = 'noopener';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
